import { render } from "./wallets-summary.vue?vue&type=template&id=5199bf73&scoped=true"
import script from "./wallets-summary.vue?vue&type=script&lang=js"
export * from "./wallets-summary.vue?vue&type=script&lang=js"

import "./wallets-summary.vue?vue&type=style&index=0&id=5199bf73&lang=scss&scoped=true"
import "./wallets-summary.vue?vue&type=style&index=1&id=5199bf73&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5199bf73"]])

export default __exports__